<template>
  <div class="mobile-page">
    <MobileNavBar :title="title" :backButtonLink="backButtonLink" :actionMenu="actionMenu" :actionDisplayNotification="actionDisplayNotification" @drawerClick="onDrawerClicked">
      <template v-slot:actionMenu>
        <slot name="actionMenu" />
      </template>
    </MobileNavBar>
    <div class="mobile-page-content">
      <slot />
    </div>
    <MobileDrawer ref="mobileDrawer">
      <slot name="drawer" />
    </MobileDrawer>
  </div>
</template>

<script>
export default {
  name: 'MobilePage',
  props: {
    title: String,
    backButtonLink: String,
    actionMenu: Boolean,
    actionDisplayNotification: Boolean
  },
  methods: {
    onDrawerClicked() {
      this.$refs.mobileDrawer.showDrawer()
    }
  }
}
</script>